import { Button } from '@/components/ui/Button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu';
import { Input } from '@/components/ui/Input';
import { Customer } from '@/generated/graphql';
import { hasNonEmptyField } from '@/utils/search-param.function';
import { Table } from '@tanstack/react-table';
import { Columns2, PlusIcon, X } from 'lucide-react';
import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { AddCustomerDialog } from './AddCustomerDialog';

export type CustomerFilter = {
  name?: string | null;
};

type ListCustomerHeaderProps = {
  table: Table<Customer>;
  filters: CustomerFilter | undefined;
  setFilters: Dispatch<SetStateAction<CustomerFilter | undefined>>;
};

export default function ListCustomerHeader({
  table,
  filters,
  setFilters,
}: ListCustomerHeaderProps) {
  const [addCustomerDialogOpen, setAddCustomerDialogOpen] =
    React.useState(false);

  const showResetFiltersButton = hasNonEmptyField(filters);

  const handleNameFilterValueChange = (
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    setFilters({ ...filters, name: event.target.value });
  };

  const handleClickResetFilters = () => {
    setFilters({});
  };
  const handleAddCustomerDialogOpen = () => {
    setAddCustomerDialogOpen(!addCustomerDialogOpen);
  };

  return (
    <>
      <div className="xs:flex-row flex flex-col gap-2">
        <div className="flex-grow">
          <Input
            placeholder="Filter by name..."
            onChange={handleNameFilterValueChange}
            className="max-w-sm"
            value={filters?.name ?? ''}
          />
        </div>
        <div className="xs:flex-end flex justify-start gap-2">
          {showResetFiltersButton && (
            <Button variant={'outline'} onClick={handleClickResetFilters}>
              <X />
              Reset
            </Button>
          )}
          <Button variant={'outline'} onClick={handleAddCustomerDialogOpen}>
            <PlusIcon />
            Add Customer
          </Button>
          <div>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="ml-auto">
                  <Columns2 />
                  Columns
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                {table
                  ?.getAllColumns()
                  .filter((column) => column.getCanHide())
                  .map((column) => {
                    return (
                      <DropdownMenuCheckboxItem
                        key={column.id}
                        className="capitalize"
                        checked={column.getIsVisible()}
                        onCheckedChange={(value) =>
                          column.toggleVisibility(!!value)
                        }
                      >
                        {column.id}
                      </DropdownMenuCheckboxItem>
                    );
                  })}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </div>
      </div>

      {addCustomerDialogOpen && (
        <AddCustomerDialog
          open={addCustomerDialogOpen}
          onToggleOpen={handleAddCustomerDialogOpen}
        />
      )}
    </>
  );
}
